import { useCallback, useEffect, useState } from 'react';
import { safeLocalStorageGetItem, safeLocalStorageSetItem } from '../utils/safeStorage';

export type ForgeTheme = 'dark' | 'light' | 'beige';

const STORAGE_KEY = 'forge-theme';

function getPreferred(): ForgeTheme {
  const stored = safeLocalStorageGetItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light' || stored === 'beige') return stored;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function nextForgeTheme(theme: ForgeTheme): ForgeTheme {
  if (theme === 'dark') return 'light';
  if (theme === 'light') return 'beige';
  return 'dark';
}

export function forgeThemeLabel(theme: ForgeTheme): string {
  return `${theme[0].toUpperCase()}${theme.slice(1)} mode`;
}

export function useForgeTheme() {
  const [theme, setTheme] = useState<ForgeTheme>(getPreferred);

  useEffect(() => {
    safeLocalStorageSetItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((current) => nextForgeTheme(current));
  }, []);

  return { theme, toggleTheme } as const;
}
